import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    // private authenticationService: AuthenticationService
    private _authService: AuthService,
    private _router: Router,
    private _activateRoute: ActivatedRoute
  ) {}
  reloadCurrentRoute() {
    const currentUrl = this._router.url;
    void this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      void this._router.navigate([currentUrl]);
    });
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if ([401, 403].includes(err.status)) {
          this._authService.logout();
          if (
            !this._router.url.includes('connexion') &&
            !this._router.url.includes('deconnexion')
          ) {
            void this._router.navigate(['/deconnexion']);
          }
        }
        const error =
          err.error?.message ||
          (typeof err.error === 'string' ? err.error : null) ||
          err.message ||
          err.statusText;
        return throwError(() => error);
      })
    );
  }
}
